import { render, staticRenderFns } from "./TurnOverList.vue?vue&type=template&id=1ea846e0"
import script from "./TurnOverList.vue?vue&type=script&lang=js"
export * from "./TurnOverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports